module.exports = __webpack_public_path__ + "2a327ab7d41f9d9e85d9a3b06516f4db.pdf";